import React, { useRef, useState } from 'react';
import styles from './ResourceShare.module.scss';
import { Tabs } from 'new/elements/Tabs';
import {
  ResourceSelection,
  ResourceType,
} from 'new/elements/ResourceShare/components/ResourceSelection/ResourceSelection';
import { FlowsTable } from 'new/components/FlowsTable';
import { Org } from 'new/entities/Org';
import { NexsetsTable } from 'new/components/NexsetsTable';
import { DestinationsTable } from 'new/components/DestinationsTable/DestinationsTable';
import { SourcesTable } from 'new/components/SourcesTable/SourcesTable';
import { User } from 'new/entities/User';
import { useDistance } from 'new/hooks/useDistance';

interface ResourceShareProps {
  org?: Org;
  user?: User;
}

const tableComponent = {
  flow: FlowsTable,
  nexset: NexsetsTable,
  destination: DestinationsTable,
  source: SourcesTable,
};

export function ResourceShare(props: ResourceShareProps) {
  const [resource, setResource] = useState('flow');
  const [sharedWith, setSharedWith] = useState<'from' | 'to'>('from');
  const ref = useRef<HTMLDivElement>();

  const tableHeight = useDistance(ref, 400);

  const entityProp = props.org ? 'org' : 'user';
  const entity = props[entityProp];
  const handleResourceChange = (value: ResourceType) => {
    setResource(value);
  };

  const handleTabChange = (event, value) => {
    setSharedWith(value);
  };

  const Table = tableComponent[resource] || FlowsTable;

  return (
    <div>
      <div className={styles.tabsContainer}>
        <Tabs
          tabs={[
            {
              label: 'Shared with me',
              value: 'from',
            },
            {
              label: 'Shared with ' + entity.name,
              value: 'to',
            },
          ]}
          defaultValue={'from'}
          value={resource}
          onChange={handleTabChange}
        />
      </div>
      <div ref={ref} className={styles.resourceSelectionContainer}>
        <ResourceSelection onChange={handleResourceChange} />
      </div>
      <Table
        shared={sharedWith}
        orgId={props?.org?.id}
        userId={props?.user?.id}
        height={tableHeight}
      />
    </div>
  );
}
